<template>
  <div ref="ProfitLossDashboardpdf" id="ProfitLossDashboardpdf">
    <CustomLoader v-if="isLoading" :width="70" />
    <b-card class="mainCardBG">
      <div class="gutr mt-3">
        <div class="row">
          <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
            <div>
              <b-navbar toggleable="lg" type="dark" variant="info">
                <b-navbar-brand style="padding: 0.475rem 1rem">
                  <transition name="custom-slide" mode="out-in">
                    <h5>{{ tabs[activeTab].name }}</h5>
                  </transition>
                </b-navbar-brand>
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button-group size="sm" class="ml-1 text-right">
                      <b-button style="font-size: 0.675rem" variant="outline-secondary" @click="goBack">Back</b-button>
                    </b-button-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>
              <div>
                <b-card>
                  <b-row>
                    <b-col md="12">
                      <div class="tab-list d-flex" role="tablist">
                        <div v-for="(tab, index) in tabs" :key="index"
                          :class="['tab-item', { 'active-tab': activeTab === index }]"
                          :aria-selected="activeTab === index ? 'true' : 'false'"
                          role="tab"
                          tabindex="0"
                          @click="changeTab(index)"
                          @keydown.enter.space="changeTab(index)">
                          {{ tab.name }}
                        </div>
                      </div>
                      <transition name="custom-slide" mode="out-in">
                        <component :is="currentTabComponent" :key="activeTab" v-model="daysFilter"
                          :tab="tabs[activeTab]" :tabName="tabs[activeTab].name" :tabIndex="activeTab" />
                      </transition>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import MilestoneTrack from "./milestoneTrack.vue";

export default {
  beforeMount() {
    const loginId = this.$sessionsStorage.get("loginId");
    if (loginId) {
      if (globalPermissionStatus("Sea Freight")) {
        this.$store.dispatch("setCurrentRoute", this.$route.path);
      } else {
        this.$router.push({ path: "/dashboard" });
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({ path: "/Login/" });
    }
  },
  watch: {
    daysFilter(newVal) {
      this.updateTabs(newVal);
    },
  },
  data() {
    return {
      activeTab: 0,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      tabs: [],
      daysFilter: '',
      isLoading: false,
    };
  },
  created() {
    this.tabs = this.generateTabs(this.daysFilter);
  },
  components: {
    CustomLoader,
    DatePicker,
    MilestoneTrack,
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component;
    },
  },
  methods: {
    generateTabs(days) {
      return [
        { name: "Main Track", component: MilestoneTrack },
        { name: "Leg 1 Changed", component: MilestoneTrack },
        { name: "Leg 2 Changed", component: MilestoneTrack },
        { name: "SOB Changed", component: MilestoneTrack },
        { name: "POL Changed", component: MilestoneTrack },
        { name: "POD Plan Changed", component: MilestoneTrack },
        { name: "POD Departure Changed", component: MilestoneTrack },
        { name: "TSP1 Changed", component: MilestoneTrack },
        { name: "TSP2 Changed", component: MilestoneTrack },
        { name: `SOB ${days}`, component: MilestoneTrack },
        { name: `POD ${days} Arrival`, component: MilestoneTrack },
        { name: `POD ${days} Departure`, component: MilestoneTrack },
        { name: `POL ${days} Arrival`, component: MilestoneTrack },
        { name: `POL ${days} Departure`, component: MilestoneTrack },
        { name: `TSP1 ${days} Arrival`, component: MilestoneTrack },
        { name: `TSP1 ${days} Departure`, component: MilestoneTrack },
        { name: `TSP2 ${days} Arrival`, component: MilestoneTrack },
        { name: `TSP2 ${days} Departure`, component: MilestoneTrack },
        { name: `DLV ${days} Arrival`, component: MilestoneTrack },
      ];
    },
    updateTabs(newVal) {
      this.tabs = this.generateTabs(newVal);
    },
    changeTab(index) {
      this.activeTab = index;
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.formCard {
  border: none !important;
  padding: 0;
}
.tab-list {
  display: flex;
  cursor: pointer;
  overflow-x: auto;
}
.tab-item {
  padding: 5px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
  outline: none;
}
.tab-item:hover, .tab-item:focus {
  background-color: #0aa46e;
  color: #fff;
  box-shadow: 0 0 0 2px #007bff33;
}
.active-tab {
  background-color: #007bff;
  color: #ffffff;
  font-weight: bold;
  box-shadow: 0 2px 8px #007bff33;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-slide-enter-active,
.custom-slide-leave-active {
  transition: transform 0.5s;
}
.custom-slide-enter,
.custom-slide-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// Tab.vue?56e2b4d2